import React from "react";
import { Route, Navigate } from "react-router-dom";
import Profile from "./Profile";
import SettingsPageWrapper from "./SettingsPageWrapper";

const SettingsPages = () => [
  <Route
    index
    key="settings/index"
    element={<Navigate to="profile" replace />}
  />,
  <Route path="profile" key="settings/profile" element={<Profile />} />,
];

export default () => {
  return (
    <Route path="settings" element={<SettingsPageWrapper />}>
      {SettingsPages()}
    </Route>
  );
};
